'use strict';

angular.module('licensure.services')
    .factory('IPStatuses', ['$http', '$q', '$rootScope', 'Cache', function ($http, $q, $rootScope, Cache) {

        return {
            get: function () {
                var d = $q.defer();

                if ($rootScope.offline) {
                    Cache.getAll('inspection_status').then(function (statuses) {
                        d.resolve(statuses);
                    })
                }
                else {
                    $http.get(apiLocation + '/api/IPStatuses', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        var promises = [];

                        response.data.forEach(function (status) {
                            promises.push(Cache.save('inspection_status', status));
                        })                        

                        $q.all(promises).then(function () {
                            d.resolve(response.data);
                        }).catch(function (response) {
                            // handle error
                        });
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    })
                }

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPStatuses/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (status) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPStatuses/';
                if (!isUndefined(status.id)) {
                    method = 'PUT'
                    url += status.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        status: status
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/IPStatuses/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }])
;